import React from "react";

import {FilterStatus, WsSensor} from "../../../store/branches/sensors/stateTypes";

import Sensor from "./Sensor";

interface SensorWrapProps {
    sensor: WsSensor,
    wsDataId: string
    groupId: string
    sensorsId?: string
    groupsId: string
    sensorId?: string
    f500GroupID?: string
    alignmentID?: string
    isAlignment?: boolean,
    sensorNumber: number,
    groupNumber: number
    filter_status: FilterStatus
    isF500Type?: boolean
    groupNameF500?: string
    groupName?: string
}


const SensorWrap: React.FC<SensorWrapProps> = ({
                                                   sensor,
                                                   wsDataId,
                                                   groupId,
                                                   sensorsId,
                                                   sensorId,
                                                   f500GroupID,
                                                   groupsId,
                                                   alignmentID,
                                                   sensorNumber,
                                                   groupNumber,
                                                   isAlignment,
                                                   filter_status,
                                                   isF500Type,
                                                   groupNameF500,
                                                   groupName
                                               }) => {
    const unit =(sensor?.Meta?.Units && typeof sensor?.Meta?.Units === "string") && sensor?.Meta?.Units.split("")[1]
    const isTemperature = unit === "F" || unit === "C";

    const isBoolean = ["BOOL", "ENUM"].indexOf(sensor.Type) !== -1;

    const contactSensor = () => {
        const isContact = sensor?.Meta?.State?.split(" ").includes("Contact");
        const ContactName = isContact && <span>{sensor?.Meta?.State?.split(" / ")[0]}</span>;
        const ContactStatus = isContact && sensor?.Meta?.State?.split(" / ")[1];
        const DefaultStatus =  sensor?.Meta?.State === 'N/A' ? '' : sensor?.Meta?.State;


        return {isContact, ContactName, ContactStatus, DefaultStatus};
    };

    const {isContact, ContactName, ContactStatus, DefaultStatus} = contactSensor();

    if (filter_status === FilterStatus.ACTIVE) {
        if (sensor?.Meta?.State === "Disabled") {
            return null;
        }
        if (sensor?.Meta?.State === 'System Selected Profile 0') {
            return null;
        }
        return <Sensor sensor={sensor}
                       wsDataId={wsDataId}
                       groupId={groupId}
                       groupsId={groupsId}
                       sensorsId={sensorsId}
                       sensorId={sensorId}
                       f500GroupID={f500GroupID}
                       alignmentID={alignmentID}
                       sensorNumber={sensorNumber}
                       groupNumber={groupNumber}
                       filter_status={filter_status}
                       isAlignment={isAlignment}
                       ContactStatus={ContactStatus}
                       ContactName={ContactName}
                       DefaultStatus={DefaultStatus}
                       isBoolean={isBoolean}
                       isTemperature={isTemperature}
                       isContact={isContact}
                       isF500Type={isF500Type}
                       groupNameF500={groupNameF500}
                       groupName={groupName}
        />;
    }


    if (sensor?.Meta?.State === 'System Selected Profile 0') {
        return null;
    }
    return <Sensor sensor={sensor}
                   wsDataId={wsDataId}
                   groupId={groupId}
                   groupsId={groupsId}
                   sensorsId={sensorsId}
                   sensorId={sensorId}
                   f500GroupID={f500GroupID}
                   alignmentID={alignmentID}
                   sensorNumber={sensorNumber}
                   groupNumber={groupNumber}
                   filter_status={filter_status}
                   isAlignment={isAlignment}
                   ContactStatus={ContactStatus}
                   ContactName={ContactName}
                   DefaultStatus={DefaultStatus}
                   isBoolean={isBoolean}
                   isTemperature={isTemperature}
                   isContact={isContact}
                   isF500Type={isF500Type}
                   groupNameF500={groupNameF500}
                   groupName={groupName}
    />;
};

export default SensorWrap;
